import { CalendarDaysIcon, ClockIcon, MapPinIcon } from '@heroicons/react/24/solid';
import { DateTime } from 'luxon';
import type { FC } from 'react';
import { formatDate } from '@/app/helpers/date.helpers';

interface EventTimeAndLocationProps {
  start: string | DateTime;
  end: string | DateTime;
  location?: string;
}

const EventTimeAndLocation: FC<EventTimeAndLocationProps> = ({ start, end, location }) => {
  return (
    <>
      <div className='flex items-center gap-3'>
        <CalendarDaysIcon className='w-5 h-5 text-primary-500 flex-shrink-0' />
        <span className='text-sm font-medium text-gray-700'>
          {formatDate(start, DateTime.DATE_FULL)}
        </span>
      </div>
      <div className='flex items-center gap-3'>
        <ClockIcon className='w-5 h-5 text-primary-500 flex-shrink-0' />
        <span className='text-sm text-gray-700'>
          {formatDate(start, DateTime.TIME_SIMPLE)} - {formatDate(end, DateTime.TIME_SIMPLE)}
        </span>
      </div>
      {location && (
        <div className='flex items-center gap-3'>
          <MapPinIcon className='w-5 h-5 text-primary-500 flex-shrink-0' />
          <span className='text-sm text-gray-700'>{location}</span>
        </div>
      )}
    </>
  );
};

export default EventTimeAndLocation;
